import React from 'react';
import css from './index.module.scss';
import { useSiteMetadata } from '../../../hooks/useSiteMetadata';
import { Logo } from '../../Logo';
// @ts-ignore
import { version } from '../../../../package.json';

interface FooterProps {}

export const Footer = (props: FooterProps) => {
  const metadata = useSiteMetadata();

  return (
    <footer className={css.container}>
      <div className={css.content}>
        <p className={css.copyright}>
          © All rights reserved | {year}
        </p>
        <Logo invert />
        <div className={css.socials}>
          <a href={metadata.social.github} title="Github profile">
            <img
              className={css.link_img}
              src="/assets/github.svg"
              alt="Github"
            />
          </a>
        </div>
        <input type="hidden" value={version} />
      </div>
    </footer>
  );
};

const year = new Date().getFullYear();
